import type { RouteComponentProps } from "react-router-dom";

import { createRedesignEntry } from "../redesign-page-entry";

export default createRedesignEntry<RouteComponentProps<{ event_id: string }>>(() => import("./event-detail-page"), {
  testId: "rd-event-detail-loading",
  // Event details use a generic breadcrumb label; the page heading contains the event title.
  shell: { activeNav: "learning", breadcrumbLeaf: { id: "redesign.shell.event_detail", defaultMessage: "Description" } },
});
